import { render } from "./Bang.vue?vue&type=template&id=1ffa3ed9&scoped=true"
import script from "./Bang.vue?vue&type=script&lang=js"
export * from "./Bang.vue?vue&type=script&lang=js"

import "./Bang.vue?vue&type=style&index=0&id=1ffa3ed9&lang=scss&scoped=true"

import exportComponent from "E:\\vue-cli-pc\\测试环境\\exp2c.com\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ffa3ed9"]])

export default __exports__